import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid } from "@material-ui/core";
import EditOutlined from "@material-ui/icons/EditOutlined";
import Search from "../../../components/Search/Search";
import DataTable from "../../../components/DataTable/DataTable";
import Filters from "../../../components/DataTable/Filters/Filters";
import CustomizeView from "../../../components/DataTable/CustomizeView/CustomizeView";
import AddAlertProfile from "./addAlertProfile/AddAlertProfile";
import AlertDialog from "./AlertDialog";
import ProfileService from "../../../services/ProfileService/ProfileService";
import DeleteConfirm from "../../../components/DataTable/DeleteConfirm";
import { alertState } from "./../../../recoil-store/recoil-state";
import { useSetRecoilState } from 'recoil';

/**
 * @Description This function returns Alert Profile page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
let deletedItems = [];
let setSelectedAutomRow;

function AlertProfile(props) {
    const label = "CONTENT.ALERT.";
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [customColumn, setCustomColumn] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [searchKeyData, setSearchKeyData] = useState("");
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [edit, setEdit] = useState({ type: "add", id: "" });
    const [openDialog, setOpenDialog] = useState({ type: "", isOpen: false, id: "" });
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        fetchData().then((r) => r);
    }, [refresh]);

    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        setOpenDelete(true);
        deletedItems = [];
        for (let i of rowsDeleted.data) {
            deletedItems.push(searchData[i.dataIndex].id);
        }
        setSelectedAutomRow = setSelectedRows;
    };

    const handleDelete = async () => {
        const ids = deletedItems;
        setLoadingDelete(true);
        const response = await ProfileService.deleteByAlertRule(ids);
        if (response) {
            if (response.status) {
                setSelectedAutomRow([]);
                fetchData().then((r) => r);
            }
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('CONTENT.ALERT.' + response.message),
                severity: response.status ? 'success' : 'error'
            }))
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoadingDelete(false);
    };

    const fetchData = async () => {
        setLoading(true);
        const response = await ProfileService.getAllListAlertRule();
        if (response) {
            if (response?.data) {
                setData(response.data);
                setSearchData(response.data);
            }
        }
        setLoading(false);
    };

    const handleEdit = (id) => {
        if (id) {
            setEdit({ type: "edit", id });
            setOpenAdd(!openAdd);
        }
    };

    function handleOpen(open, setState) {
        setState(!open);
        setEdit({ type: "add", id: "" })
    }

    useEffect(() => {
        const column = [
            {
                id: 0,
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 1,
                name: "name",
                label: t(label + "PROFILE-NAME"),
                options: { filter: true, sort: false },
            },
            {
                id: 2,
                name: "description",
                label: t(label + "DESC"),
                options: { filter: true, sort: false },
            },
            {
                id: 3,
                name: "autom_count",
                label: t(label + "AUTOMS"),
                options: {
                    filter: true,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <>
                                    {searchData[dataIndex]?.autom_count > 0 ? (
                                        <>
                                            {searchData[dataIndex]?.autom_count}
                                            <button
                                                onClick={() =>
                                                    setOpenDialog({
                                                        type: "automs",
                                                        isOpen: true,
                                                        id: searchData[dataIndex]?.id
                                                    })
                                                }
                                                className="user-detail-link"
                                            >
                                                ({t(label + "VIEW-ALL")})
                                            </button>
                                        </>
                                    ) : (
                                        "All Automs"
                                    )}
                                </>
                            );
                        }
                    },
                },
            },
            {
                id: 4,
                name: "action_profile_count",
                label: t(label + "ACTIONEER-PROFILE"),
                options: {
                    filter: true,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <>
                                    {searchData[dataIndex]?.action_profile_count}
                                    {searchData[dataIndex]?.action_profile_count > 0 &&
                                        <button
                                            onClick={() =>
                                                setOpenDialog({
                                                    type: "actioneer-profile",
                                                    isOpen: true,
                                                    id: searchData[dataIndex]?.id
                                                })
                                            }
                                            className="user-detail-link"
                                        >
                                            ({t(label + "VIEW-ALL")})
                                        </button>}
                                </>
                            );
                        }
                    },
                },
            },
            {
                id: 5,
                name: "alert_rule_count",
                label: t(label + "ALERT-RULE"),
                options: {
                    filter: true,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <>
                                    {searchData[dataIndex]?.alert_rule_count}
                                    {searchData[dataIndex]?.alert_rule_count > 0 &&
                                        <button
                                            onClick={() =>
                                                setOpenDialog({
                                                    type: "alert-rule",
                                                    isOpen: true,
                                                    id: searchData[dataIndex]?.id
                                                })
                                            }
                                            className="user-detail-link"
                                        >
                                            ({t(label + "VIEW-ALL")})
                                        </button>
                                    }
                                </>
                            );
                        }
                    },
                },
            },
            {
                id: 6,
                name: "actions",
                label: t(label + "ACTIONS"),
                options: {
                    filter: true,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <>
                                    <Button
                                        onClick={() => handleEdit(searchData[dataIndex].id)}
                                        size="small"
                                    >
                                        <EditOutlined
                                            fontSize="small"
                                            color="disabled"
                                            style={{ margin: "0 5px 0 -20px" }}
                                        />
                                        <span className="db-sublabel">{t(label + "EDIT")}</span>
                                    </Button>
                                </>
                            );
                        }
                    },
                },
            },
        ];
        setCustomColumn(column);
        setSearchKeyData(["name", "description"]);
    }, [searchData, setSearchKeyData]);

    return (
        <div id="credential-container" className='data-body-container'>
            <Search
                data={data} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                setSearchData={setSearchData}
                searchKey={searchKeyData}
            >
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Button
                        className="searchbar-button"
                        onClick={() => handleOpen(openAdd, setOpenAdd)}
                    >
                        {t(label + "ADD-ALERT-PROFILE")}
                    </Button>
                    <Button
                        className="searchbar-button"
                        onClick={() => setOpenCustomizeView(!openCustomizeView)}
                    >
                        {t("CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW")}
                    </Button>
                    <Button
                        className="searchbar-button"
                        onClick={() => setOpenFilters(!openFilters)}
                    >
                        {t("CONTENT.DATATABLE.TOOLBAR.FILTERS")}
                    </Button>
                </Grid>
            </Search>
            <DataTable
                data={searchData}
                customColumns={customColumn}
                loading={loading}
                selectableRows="multiple"
                loadingDelete={loadingDelete}
                onRowsDelete={handleRowsDelete}
                selectedRowMessage={label + "ALERT-SELECTED-MESSAGE"}
                perPageMessage={label + "PER-PAGE-MESSAGE"}
            />
            {openCustomizeView && (
                <CustomizeView
                    setOpen={setOpenCustomizeView}
                    customColumn={customColumn}
                    setCustomColumn={setCustomColumn}
                />
            )}
            {openFilters && (
                <Filters
                    setOpen={setOpenFilters}
                    customColumn={customColumn}
                    setCustomColumn={setCustomColumn}
                />
            )}
            {openDelete && (
                <DeleteConfirm
                    setOpenDelete={setOpenDelete}
                    message={t("CONTENT.ALERT.DELETE-MESSAGE")}
                    deleteFunc={handleDelete}
                />
            )}
            {openDialog?.isOpen && <AlertDialog open={openDialog} setOpen={setOpenDialog} />}
            {openAdd && (
                <AddAlertProfile setOpen={setOpenAdd} setRefresh={setRefresh} edit={edit} />
            )}
        </div>
    );
}

export default AlertProfile;
